import { Inject, Injectable } from '@angular/core'

import { LOCATION } from '../../variables'
import { BackendService, RequestOptionsArgs } from '../backend/backend.service'

@Injectable()
export class HelpCenterService {
  apiEndpoint: string

  constructor(@Inject(LOCATION) private location: any, private backendService: BackendService) {
    const parts = location.hostname.split('.').slice(1)
    this.apiEndpoint = ['help-center', ...parts].join('.')
  }

  public loadArticle(articleId: number, options: RequestOptionsArgs = {}) {
    const url = `//${this.apiEndpoint}/api/articles/${articleId}`
    var requestOptions = Object.assign({}, options)
    requestOptions.withCredentials = true
    requestOptions.skipLoader = true
    return this.backendService.load(url, requestOptions)
  }
}
